import pdfImage from "../../assets/Home/pdfImage.svg";
import style from "./style.module.css";
const reformDoc = [
	{
		id: 1,
		image: pdfImage,
		name: "Joint Revenue Board (Establishment) act, 2025",
		button: "Download ",
		pdfUrl: "https://beamish-gingersnap-9fe24e.netlify.app/docs/(FINAL%20COPY)%20JOINT%20REVENUE%20BOARD%20(ESTABLISHMENT)%20ACT%2C%202025.pdf"
	},
	{
		id: 2,
		image: pdfImage,
		name: "Nigeria Revenue Service (Establishment) act, 2025",
		button: "Download ",
		pdfUrl: "https://beamish-gingersnap-9fe24e.netlify.app/docs/(FINAL%20COPY)%20NIGERIA%20REVENUE%20SERVICE%20(ESTABLISHMENT)%20ACT%2C%202025.pdf"
	},
	{
		id: 3,
		image: pdfImage,
		name: "Nigerian Tax act, 2025",
		button: "Download ",
		pdfUrl: "https://beamish-gingersnap-9fe24e.netlify.app/docs/(FINAL%20COPY)%20NIGERIA%20TAX%20ACT%2C%202025.pdf"
	},
	{
		id: 4,
		image: pdfImage,
		name: "Nigerian Tax Administration act, 2025",
		button: "Download ",
		pdfUrl: "https://beamish-gingersnap-9fe24e.netlify.app/docs/(FINAL%20COPY)%20NIGERIA%20TAX%20ADMINISTRATION%20ACT%2C%202025.pdf"
	}
];

const ReformDoc = () => {
	const handleDownload = (pdfUrl, fileName) => {
		// Create an anchor element
		const link = document.createElement("a");
		link.href = pdfUrl;
		link.download = fileName;
		link.target = "_blank";

		// Trigger the download
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<section className={style.reformDocSection}>
			<p className={style.reformHeading}>
				Get Access to the 2026 Newly Signed <br /> Tax Reformed Bills
				and Laws
			</p>
			<div className={style.reformCards}>
				{reformDoc.map((doc) => (
					<div key={doc.id} className={style.reformCard}>
						<img src={doc.image} alt="pdf" />
						<div className={style.reformContent}>
							<p>{doc.name}</p>
							<button
								onClick={() =>
									handleDownload(doc.pdfUrl, doc.fileName)
								}
							>
								{doc.button}
							</button>
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default ReformDoc;
